import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 37 37"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m25.547 21.852 10.164 8.81c.923.8 1.024 2.209.224 3.132l-.363.419a2.227 2.227 0 0 1-3.132.223l-10.088-8.744"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M.871 15.34C.871 8.034 6.793 2.111 14.1 2.111c7.305 0 13.227 5.922 13.227 13.228 0 7.305-5.922 13.227-13.227 13.227S.87 22.645.87 15.34m13.396 9.666c5.338 0 9.666-4.328 9.666-9.667a9.666 9.666 0 0 0-9.666-9.666c-5.34 0-9.667 4.328-9.667 9.666 0 5.34 4.328 9.667 9.667 9.667"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }